import { Badge, Space } from 'antd'
import React from 'react'
import { OrderSettledStates } from '../api/TourniiAPI';

function OrderSettledStateBadge({ state }) {
    let name = state;
    let color = null;
    const found = OrderSettledStates.find((row) => row.id === state);
    if (found) {
        name = found.name;
        color = found.color;
    }
    return (
        <Space>
            <Badge status={color} />{name}
        </Space>
    )
}

export default OrderSettledStateBadge